const STORAGE_KEY = 'supportSession';

export function readSupportSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    if (!data.expiresAtMs || Date.now() >= data.expiresAtMs) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch (_) {
    return null;
  }
}

export function saveSupportSession(session) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch (_) {
    /* ignore */
  }
}

export function clearSupportSession() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function isSupportSessionForCompany(session, company) {
  if (!session) return false;
  const slug = (company || '').toString().trim().toLowerCase();
  return slug && session.company === slug && session.expiresAtMs && Date.now() < session.expiresAtMs;
}
